export default "__VITE_ASSET__bb8d6cd4__"